var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUpvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#262551"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1355 15.3018C12.9008 14.9207 12.4797 14.6667 11.9993 14.6667H9.99935C9.26297 14.6667 8.66602 15.2636 8.66602 16V20.6667C8.66602 21.403 9.26297 22 9.99935 22H11.9993C12.6256 22 13.1511 21.5682 13.2942 20.9861M13.1355 15.3018C13.2605 15.5049 13.3327 15.744 13.3327 16V20.6667C13.3327 20.7768 13.3193 20.8837 13.2942 20.9861M13.1355 15.3018C13.912 15.0861 14.6768 14.2701 15.0007 13.5296L16.1848 10.8231C16.4604 10.1932 17.1593 9.86418 17.8204 10.0531C18.492 10.245 18.9126 10.9104 18.7978 11.5994L18.4621 13.6136C18.3943 14.02 18.7077 14.3899 19.1197 14.3899H21.7063C22.5477 14.3899 23.1787 15.1597 23.0137 15.9847L22.2469 19.8188C22.0957 20.575 21.5241 21.1828 20.7718 21.3522C18.063 21.9619 16.4824 21.8329 13.2942 20.9861",
    stroke: "#4ED5D2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUpvote);
export default __webpack_public_path__ + "static/media/activeUpvote.aa3a6f42e8bf4a65447669f3983f1e51.svg";
export { ForwardRef as ReactComponent };